import DataScienceFoundation from "../../../../../assets/Courses/datasciencecourses/DataScienceFoundation.webp";
import PythonforDataScience from "../../../../../assets/Courses/datasciencecourses/PythonforDataScience.webp";
import SQLforDataScience  from "../../../../../assets/Courses/datasciencecourses/SQLforDataScience.webp";
import StatisticsforDataScience from "../../../../../assets/Courses/datasciencecourses/StatisticsforDataScience.webp";
import IntroductiontoBusinessIntelligence from "../../../../../assets/Courses/datasciencecourses/IntroductiontoBusinessIntelligence.webp";
import MasteringTableau from "../../../../../assets/Courses/datasciencecourses/MasteringTableauDataVisualizationandBusinessIntelligence.webp";
import DataVisualization from "../../../../../assets/Courses/datasciencecourses/DataVisualization.webp";
import GoogleLookerStudio from "../../../../../assets/Courses/datasciencecourses/MasteringGoogleLookerStudioDataVisualizationandBusinessIntelligence.webp";
import PowerBI from "../../../../../assets/Courses/datasciencecourses/MasteringPowerBIDataAnalyticsandVisualizationwithHands-OnProjects.webp";
import MathematicsDataScience from "../../../../../assets/Courses/datasciencecourses/MathematicsforDataScience.webp";
import MachineLearningEssentials from "../../../../../assets/Courses/datasciencecourses/machineLearningEssentialsFoundations.webp";
import AdvancedMachineLearning from "../../../../../assets/Courses/datasciencecourses/AdvancedMachineLearning.webp";
import QlikSense from "../../../../../assets/Courses/datasciencecourses/MasteringQlikSenseDataVisualizationandAnalytics.webp";
import MachineLearningModelDeployment from "../../../../../assets/Courses/datasciencecourses/MachineLearningModelDeploymentUsingFlask.webp";
import TimeSeriesFoundation from "../../../../../assets/Courses/datasciencecourses/TimeSeriesFoundation.webp";
import DeepLearning from "../../../../../assets/Courses/datasciencecourses/DeepLearning.webp";
import NaturalLanguageProcessing from "../../../../../assets/Courses/datasciencecourses/NaturalLanguageProcessing.webp";
import ReinforcementLearning from "../../../../../assets/Courses/datasciencecourses/ReinforcementLearning.webp";
import AIFundamentals from "../../../../../assets/Courses/datasciencecourses/fundamentals.webp";
import DataEngineeringFundamentals from "../../../../../assets/Courses/datasciencecourses/DataEngineeringFundamentals.webp";
import AzureDataEngineering from "../../../../../assets/Courses/datasciencecourses/MicrosoftAzureDataEngineering.webp";
import MasteringApacheKafka from "../../../../../assets/Courses/datasciencecourses/MasteringApacheKafkaHands-OnDistributedStreamingandDataPipelines.webp";
import MasteringDatabricks from "../../../../../assets/Courses/datasciencecourses/MasteringDatabricksEnd-to-EndDataEngineeringandAnalyticswithApacheSpark.webp";
import MasteringSnowflake from "../../../../../assets/Courses/datasciencecourses/MasteringSnowflakeHands-OnCloudDataWarehousingandAnalytics.webp";
import GenerativeAIFundamentals from "../../../../../assets/Courses/datasciencecourses/AIFundamentals.webp";
import GenerativeAICourse from "../../../../../assets/Courses/datasciencecourses/CompleteGenerativeAICourse.webp";
import GenerativeAdversarialNetworks from "../../../../../assets/Courses/datasciencecourses/GenerativeAdverarialNetworks.webp";
import CaseStudies from "../../../../../assets/Courses/datasciencecourses/generativeAIApplicationsCaseStudies.webp";
import PromptEngineering from "../../../../../assets/Courses/datasciencecourses/promptEngineering.webp";
import FineTuningLLMs from "../../../../../assets/Courses/datasciencecourses/fineTuningLLMs.webp";
import ProbabilityStatistics from "../../../../../assets/Courses/datasciencecourses/probabilityStatisticsDataScience.webp";
import ArtificialIntelligence from "../../../../../assets/Courses/datasciencecourses/artificialIntelligenceofThings.webp";
import EngineeringMathematics from "../../../../../assets/Courses/datasciencecourses/engineeringMathematics.webp";

const BusinessIntelligenceCourses = [
  {
    category: "DATA SCIENCE",
    learningPath: "Business Intelligence",
    courses: [
  {
    courseId: 1,
    courseTitle: "Data Science Foundation",
    videoUrl: "67cc3b2468e13f369550b03f",
    image: DataScienceFoundation,
    completion: 0
  },
  {
    courseId: 2,
    courseTitle: "Python for Data Science",
    videoUrl: "67cc3d71a4b1024b47180dc9",
    image: PythonforDataScience,
    completion: 0
  },
  {
    courseId: 3,
    courseTitle: "SQL for Data Science",
    videoUrl: "67cc3e102d97eb150f84e3ca",
    image: SQLforDataScience,
    completion: 0
  },
  {
    courseId: 4,
    courseTitle: "Statistics for Data Science",
    videoUrl: "67cc3e9e68e13f369550b1c6",
    image: StatisticsforDataScience,
    completion: 0
  },
  {
    courseId: 5,
    courseTitle: "Introduction to Business Intelligence",
    videoUrl: "67cc3f96b4067e5a81ed473d",
    image:  IntroductiontoBusinessIntelligence,
    completion: 0
  },
  {
    courseId: 6,
    courseTitle: "Mastering Tableau: Data Visualization and Business Intelligence",
    videoUrl: "67cc408d137adb27bed51545", 
    image: MasteringTableau,
    completion: 0
  },
  {
    courseId: 7,
    courseTitle: "Data Visualization",
    videoUrl: "67cc4163c08b970ba4cd7d59",
    image: DataVisualization,
    completion: 0
  },
  {
    courseId: 8,
    courseTitle: "Mastering Google Looker Studio: Data Visualization and Business Intelligence",
    videoUrl: "67cc421c2754491fdbc6230c", 
    image: GoogleLookerStudio,
    completion: 0
  },
  {
    courseId: 9,
    courseTitle: "Mastering Power BI: Data Analytics and Visualization with Hands-Oncoursess",
    videoUrl: "67cc426093d38d2542d40703", 
    image: PowerBI,
    completion: 0
  },
  {
    courseId: 10,
    courseTitle: "Mastering Qlik Sense: Data Visualization and Analytics",
    videoUrl: "67cc43a50403f96395ff1d36", 
    image: QlikSense,
    completion: 0
  }
]
  }
];

const MachineLearningAICourses = [
  {
    category: "DATA SCIENCE",
    learningPath: "Machine Learning and AI",
    courses: [
    {
      courseId: 1,
      courseTitle: "Data Science Foundation",
      videoUrl: "67cc3b2468e13f369550b03f",
      image: DataScienceFoundation,
      completion: 0
    },
    {
      courseId: 2,
      courseTitle: "Python for Data Science",
      videoUrl: "67cc3d71a4b1024b47180dc9",
      image: PythonforDataScience,
      completion: 0
    },
    {
      courseId: 3,
      courseTitle: "SQL for Data Science",
      videoUrl: "67cc3e102d97eb150f84e3ca",
      image: SQLforDataScience,
      completion: 0
    },
    {
      courseId: 4,
      courseTitle: "Statistics for Data Science",
      videoUrl: "67cc3e9e68e13f369550b1c6",
      image: StatisticsforDataScience,
      completion: 0
    },
    {
      courseId: 5,
      courseTitle: "Mathematics for Data Science",
      videoUrl: "67cc456ac4bdd4717d1b1622",
      image:  MathematicsDataScience,
      completion: 0
    },
    {
      courseId: 6,
      courseTitle: "Data Visualization",
      videoUrl: "67cc4163c08b970ba4cd7d59", 
      image: DataVisualization,
      completion: 0
    },
    {
      courseId: 7,
      courseTitle: "Machine Learning Essentials Foundations and Key Algorithms",
      videoUrl: "67cc46192d97eb150f84eb46",
      image: MachineLearningEssentials,
      completion: 0
    },
    {
      courseId: 8,
      courseTitle: "Advanced Machine Learning",
      videoUrl: "67ce6a18ccd9fa59a5a062e5", 
      image: AdvancedMachineLearning,
      completion: 0
    },
    {
      courseId: 9,
      courseTitle: "Machine Learning Model Deployment Using Flask",
      videoUrl: "67ce6abae771eb20e9c08d45", 
      image: MachineLearningModelDeployment,
      completion: 0
    },
    {
      courseId: 10,
      courseTitle: "Time Series Foundation",
      videoUrl: "67ce6b90e505b8439864e911", 
      image: TimeSeriesFoundation,
      completion: 0
    },
    {
        courseId: 11,
        courseTitle: "Deep Learning",
        videoUrl: "67ce6caf1833130b6d1e08cb", 
        image: DeepLearning,
        completion: 0
      },
      {
        courseId: 12,
        courseTitle: "Natural Language Processing",
        videoUrl: "67ce6d52d251915979bbfec4", 
        image: NaturalLanguageProcessing,
        completion: 0
      },
      {
        courseId: 13,
        courseTitle: "Reinforcement Learning",
        videoUrl: "67ce6ddadffe0f239fd47634", 
        image: ReinforcementLearning,
        completion: 0
      },
      {
        courseId: 14,
        courseTitle: "AI Fundamentals",
        videoUrl: "67ce6e87dffe0f239fd4768e", 
        image: AIFundamentals,
        completion: 0
      }
    ]
  }
  ];

  const DataEngineeringCourses = [
    {
      category: "DATA SCIENCE",
      learningPath: "Data Engineering",
      courses: [
    {
      courseId: 1,
      courseTitle: "Data Science Foundation",
      videoUrl: "67cc3b2468e13f369550b03f",
      image: DataScienceFoundation,
      completion: 0
    },
    {
      courseId: 2,
      courseTitle: "Python for Data Science",
      videoUrl: "67cc3d71a4b1024b47180dc9",
      image: PythonforDataScience,
      completion: 0
    },
    {
      courseId: 3,
      courseTitle: "SQL for Data Science",
      videoUrl: "67cc3e102d97eb150f84e3ca",
      image: SQLforDataScience,
      completion: 0
    },
    {
      courseId: 4,
      courseTitle: "Mastering Power BI: Data Analytics and Visualization with Hands-On Projects",
      videoUrl: "67cc426093d38d2542d40703",
      image: PowerBI,
      completion: 0
    },
    {
      courseId: 5,
      courseTitle: "Data Engineering Fundamentals",
      videoUrl: "67ce711be771eb20e9c09207",
      image:  DataEngineeringFundamentals,
      completion: 0
    },
    {
      courseId: 6,
      courseTitle: "Microsoft Azure Data Engineering",
      videoUrl: "67ce71817d789843d4bb9214", 
      image: AzureDataEngineering,
      completion: 0
    },
    {
      courseId: 7,
      courseTitle: "Mastering Apache Kafka: Hands-On Distributed Streaming and Data Pipelines",
      videoUrl: "67ce7226e505b8439864efa5",
      image: MasteringApacheKafka,
      completion: 0
    },
    {
      courseId: 8,
      courseTitle: "Mastering Databricks: End-to-End Data Engineering and Analytics with Apache Spark",
      videoUrl: "67ce72b97d789843d4bb94bd", 
      image: MasteringDatabricks,
      completion: 0
    },
    {
      courseId: 9,
      courseTitle: "Mastering Snowflake: Hands-On Cloud Data Warehousing and Analytics",
      videoUrl: "67ce7334dffe0f239fd47a34", 
      image: MasteringSnowflake,
      completion: 0
    },
  ]
}
  ];

  const GenerativeAICourses = [
    {
      category: "DATA SCIENCE",
      learningPath: "Generative AI",
      courses: [
    {
      courseId: 1,
      courseTitle: "Python for Data Science",
      videoUrl: "67cc3d71a4b1024b47180dc9",
      image: PythonforDataScience,
      completion: 0
    },
    {
      courseId: 2,
      courseTitle: "Deep Learning",
      videoUrl: "67ce6caf1833130b6d1e08cb",
      image: DeepLearning,
      completion: 0
    },
    {
      courseId: 3,
      courseTitle: "Natural Language Processing",
      videoUrl: "67ce6d52d251915979bbfec4",
      image: NaturalLanguageProcessing,
      completion: 0
    },
    {
      courseId: 4,
      courseTitle: "Generative AI Fundamentals",
      videoUrl: "67ce73eb30ebe304dfecf2b4",
      image: GenerativeAIFundamentals,
      completion: 0
    },
    {
      courseId: 5,
      courseTitle: "Complete Generative AI Course",
      videoUrl: "67ce7453e771eb20e9c09431",
      image:  GenerativeAICourse,
      completion: 0
    },
    {
      courseId: 6,
      courseTitle: "Generative Adversarial Networks",
      videoUrl: "67ce74b4d251915979bc0528", 
      image: GenerativeAdversarialNetworks,
      completion: 0
    },
    {
      courseId: 7,
      courseTitle: "Generative AI Applications and Case Studies",
      videoUrl: "67ce77d130ebe304dfecf601",
      image: CaseStudies,
      completion: 0
    },
    {
      courseId: 8,
      courseTitle: "Prompt Engineering",
      videoUrl: "67ce789bccd9fa59a5a070b8", 
      image: PromptEngineering,
      completion: 0
    },
    {
      courseId: 9,
      courseTitle: "Fine Tuning LLM’s",
      videoUrl: "67ce78d3ccd9fa59a5a070f8", 
      image: FineTuningLLMs,
      completion: 0
    },
  ]
}
];

  const CertifiedDataScientistCourses = [
    {
      category: "DATA SCIENCE",
      learningPath: "Certified Data Scientist",
      courses: [
    {
      courseId: 1,
      courseTitle: "Data Science Foundation",
      videoUrl: "67cc3b2468e13f369550b03f",
      image: DataScienceFoundation,
      completion: 0
    },
    {
      courseId: 2,
      courseTitle: "Python for Data Science",
      videoUrl: "67cc3d71a4b1024b47180dc9",
      image: PythonforDataScience,
      completion: 0
    },
    {
      courseId: 3,
      courseTitle: "Statistics for Data Science",
      videoUrl: "67cc3e9e68e13f369550b1c6",
      image: StatisticsforDataScience,
      completion: 0
    },
    {
      courseId: 4,
      courseTitle: "SQL for Data Science",
      videoUrl: "67cc3e102d97eb150f84e3ca",
      image: SQLforDataScience,
      completion: 0
    },
    {
      courseId: 5,
      courseTitle: "Data Visualization",
      videoUrl: "67cc4163c08b970ba4cd7d59",
      image:  DataVisualization,
      completion: 0
    },
    {
      courseId: 6,
      courseTitle: "Machine Learning Essentials Foundations and Key Algorithms",
      videoUrl: "67cc46192d97eb150f84eb46", 
      image: MachineLearningEssentials,
      completion: 0
    },
    {
      courseId: 7,
      courseTitle: "Advanced Machine Learning",
      videoUrl: "67ce6a18ccd9fa59a5a062e5",
      image: AdvancedMachineLearning,
      completion: 0
    },
    {
      courseId: 8,
      courseTitle: "Machine Learning Model Deployment Using Flask",
      videoUrl: "67ce6abae771eb20e9c08d45", 
      image: MachineLearningModelDeployment,
      completion: 0
    },
    {
      courseId: 9,
      courseTitle: "Time Series Foundation",
      videoUrl: "67ce6b90e505b8439864e911", 
      image: TimeSeriesFoundation,
      completion: 0
    },
    {
      courseId: 10,
      courseTitle: "Deep Learning",
      videoUrl: "67ce6caf1833130b6d1e08cb", 
      image: DeepLearning,
      completion: 0
    },
    {
      courseId: 11,
      courseTitle: "Natural Language Processing",
      videoUrl: "67ce6d52d251915979bbfec4", 
      image: NaturalLanguageProcessing,
      completion: 0
    },
    ]
  }
  ];

  const DataScienceArtificialIntelligenceCourses = [
    {
      category: "DATA SCIENCE",
      learningPath: "GATE DA",
      courses: [
    {
      courseId: 1,
      courseTitle: "Python for Data Science",
      videoUrl: "67cc3d71a4b1024b47180dc9",
      image: PythonforDataScience,
      completion: 0
    },
    {
      courseId: 2,
      courseTitle: "Probability & Statistics for Data Science",
      videoUrl: "67ce79f8c164b26b6f3a6216",
      image: ProbabilityStatistics,
      completion: 0
    },
    {
      courseId: 3,
      courseTitle: "Mathematics for Data Science",
      videoUrl: "67cc456ac4bdd4717d1b1622",
      image: MathematicsDataScience,
      completion: 0
    },
    {
      courseId: 4,
      courseTitle: "SQL for Data Science",
      videoUrl: "67cc3e102d97eb150f84e3ca",
      image: SQLforDataScience,
      completion: 0
    },
    {
      courseId: 5,
      courseTitle: "Machine Learning Essentials Foundations and Key Algorithms",
      videoUrl: "67cc46192d97eb150f84eb46",
      image:  MachineLearningEssentials,
      completion: 0
    },
    {
      courseId: 6,
      courseTitle: "Advanced Machine Learning",
      videoUrl: "67ce6a18ccd9fa59a5a062e5", 
      image: AdvancedMachineLearning,
      completion: 0
    },
    {
      courseId: 7,
      courseTitle: "Deep Learning",
      videoUrl: "67ce6caf1833130b6d1e08cb",
      image: DeepLearning,
      completion: 0
    },
    {
      courseId: 8,
      courseTitle: "Artificial Intelligence",
      videoUrl: "67f3d90e7679a77909de97b1", 
      image: ArtificialIntelligence,
      completion: 0
    },
    {
      courseId: 9,
      courseTitle: "Engineering Mathematics",
      videoUrl: "67ce7ae6b464d11201985261", 
      image: EngineeringMathematics,
      completion: 0
    },
  ]
}
  ];

export { BusinessIntelligenceCourses, MachineLearningAICourses, DataEngineeringCourses, 
  GenerativeAICourses, CertifiedDataScientistCourses, DataScienceArtificialIntelligenceCourses  };